export default __webpack_public_path__ + "d78c855.png";